import { RenderedProductRowTitleCell } from "../product";

export const RenderedSubProductRowTitleCell = RenderedProductRowTitleCell;
